import React from 'react';
import styled from 'styled-components';
import {
  CpHeading03Primary,
  CpBody03Placeholder,
  CpBody03Primary,
  CpBody01Secondary,
  CpBody01Link,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpResourcesVariantWidgetProps } from '../types';

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
    margin-bottom: 0;
  }
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Subtitle = styled(CpBody03Placeholder)`
  margin-bottom: 0;
`;

export const ResourcesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--cp-spacing-05);
  width: 100%;
  /* padding-top: 40px; */

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    /* grid-gap: 0; */
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  overflow-y: hidden;
  gap: var(--cp-spacing-06);
`;

export const ResourceCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--cp-spacing-06);
  padding: var(--cp-spacing-06);
  border: 1px solid var(--Border-border-subtle, rgba(0, 0, 0, 0.12));
  background-color: white;
  height: 100%;
`;

export const ResourceImage = styled.img`
  margin-bottom: 0;
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

export const ResourceName = styled(CpBody03Primary)``;

export const ResourceDescription = styled(CpBody01Secondary)`
  text-align: left;
`;

export const ResourceCtaLink = styled(CpBody01Link)``;

export const CpResourcesGrid: React.FC<CpResourcesVariantWidgetProps> = ({
  data,
  widget,
}) => {
  const { title, description } = data;
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper background={background}>
      <Wrapper>
        <TitleWrapper>
          <Title autoAdjustColor>{title}</Title>
          <Subtitle autoAdjustColor>{description}</Subtitle>
        </TitleWrapper>
        <ResourcesGrid>
          {data?.resources?.map((resource) => (
            <ResourceCard>
              <ResourceImage src={resource?.image?.attachment?.location} />
              <ResourceName>{resource?.title}</ResourceName>
              <ResourceDescription>{resource?.description}</ResourceDescription>
              <ResourceCtaLink>
                <a href={resource?.ctaLink} target="_blank" rel="noreferrer">
                  {resource?.cta}
                </a>
              </ResourceCtaLink>
            </ResourceCard>
          ))}
        </ResourcesGrid>
      </Wrapper>
    </CpSectionWrapper>
  );
};
